import React from 'react';
import styled from 'styled-components';
import { arrayOf, node, oneOfType, string } from 'prop-types';

import exportWithBoundary from '../../../../helpers/exportWithBoundary';

export const GridHeaderContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  &.grid__scrolling {
    margin-right: 8px;
  }
`;

function GridHeader({ children, columns }) {
  const childEls = Array.isArray(children) ? children : [children];

  return (
    <GridHeaderContainer className='grid_header'>
      {childEls
        .filter((x) => React.isValidElement(x))
        .map((x, i) =>
          React.cloneElement(x, {
            // eslint-disable-next-line react/no-array-index-key
            key: `grid-header_${i}`,
            columns,
            ...(x.props || {}),
          })
        )}
    </GridHeaderContainer>
  );
}

GridHeader.defaultProps = {
  children: [],
};

GridHeader.propTypes = {
  children: oneOfType([arrayOf(node), node]),
  columns: string.isRequired,
};

function GridHeaderFallback() {
  return <GridHeaderContainer />;
}

export default exportWithBoundary(GridHeader, GridHeaderFallback);
